import { useState, useRef, useEffect } from 'react'
import { canUseDOM } from '../lib/utils'

/**
 * Tracks the window scroll position and direction.
 * SSR safe — returns 0 and 'up' on the server.
 *
 * @returns {{ scrollY: number, direction: 'up' | 'down' }}
 */
export default function useWindowScroll() {
  const [state, setState] = useState({ scrollY: canUseDOM ? window.scrollY : 0, direction: 'up' })
  const prevScrollY = useRef(state.scrollY)

  useEffect(() => {
    const handleScroll = () => {
      const current = window.scrollY
      setState({
        scrollY: current,
        direction: current > prevScrollY.current ? 'down' : 'up',
      })
      prevScrollY.current = current
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return { ...state }
}
